module.exports = __webpack_public_path__ + "img/ssfl.3eb7cc59.svg";